/**
 * 判断当前环境是否为期货通客户端
 * @returns {boolean} 如果是期货通客户端返回 true，否则返回 false
 * @example
 * ```ts
 * isInFuturesApp(); // => true (在期货通客户端内)
 * isInFuturesApp(); // => false (在浏览器中)
 * ```
 */
export function isInFuturesApp(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  
  const ua = navigator.userAgent;
  return /Futures/i.test(ua);
}
